<template>
  <ul class="flex gap-1 w-full">
    <li
      v-if="previousPage"
      @click="changePage(previousPage)"
      class="flex w-5 h-5 bg-gray-100 justify-center items-center rounded-md cursor-pointer">
      <i class="material-icons text-xs">chevron_left</i>
    </li>
    <li
      v-for="pageNumber in pages"
      :key="pageNumber"
      @click="changePage(pageNumber)"
      :class="`flex w-5 h-5 bg-gray-100 justify-center items-center rounded-md cursor-pointer ${pageNumber === currentPage ? 'bg-gray-400 text-gray-500' : ''}`">
      <span class="text-xs">{{ pageNumber }}</span>
    </li>
    <li
      v-if="nextPage <= totalPage"
      @click="changePage(nextPage)"
      class="flex w-5 h-5 bg-gray-100 justify-center items-center rounded-md cursor-pointer">
      <i class="material-icons text-xs">chevron_right</i>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    offset: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    numbers: {
      type: Number,
      default: 5
    },
    handler: null
  },
  data: () => ({
    totalPage: null,
    previousPage: null,
    nextPage: null,
    currentPage: null
  }),
  computed: {
    pages: function () {
      return this.getPages()
    }
  },
  methods: {
    getPages: function () {
      const pages = []

      let totalPage = Math.ceil(this.total / this.limit);
      let currentPage = Math.ceil((this.offset + 1) / this.limit);
          currentPage = currentPage == 0 ? 1 : currentPage;
      let firstPage = (currentPage % this.numbers);
          firstPage = (firstPage == 0 ? (currentPage - this.numbers) : (currentPage - firstPage)) + 1;
      let lastPage = (firstPage + this.numbers) - 1;
          lastPage = lastPage >= totalPage ? totalPage : lastPage;

      if (totalPage > 1) {
        for (var i = firstPage; i <= lastPage; i++) {
          pages.push(i)
        }
      }

      this.totalPage = totalPage
      this.previousPage = currentPage - 1
      this.nextPage = currentPage + 1
      this.currentPage = currentPage

      return pages
    },
    changePage: function (pageNumber) {
      const offset = ((pageNumber * this.limit) - this.limit)

      this.previousPage = pageNumber - 1
      this.nextPage = pageNumber + 1

      this.handler({
        offset: offset,
        limit: this.limit
      })
    }
  }
}
</script>
